import tableRelatedSpaceThirdParty from './tableRelatedSpaceThirdParty';

export default {
  title: 'Blocking Provider',
  attributeName: 'blockingProviders',
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRelatedSpaceThirdParty
};
